var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { View, Animated, Easing, StyleSheet } from 'react-native';
import { withTheme } from '../../theme';
const DOT_SIZE = 24;
const RIPPLE_FACTOR = 0.54;
const DOT_COUNT = 3; // #1 is the inner dot, #2 and #3 are the ripples
const animationConfig = {
    duration: 2000,
    easing: Easing.out(Easing.ease),
};
class NewIndicator extends PureComponent {
    constructor(props) {
        super(props);
        this.renderDots = (_, index) => {
            const { color, theme } = this.props;
            const dotColor = color ? color : theme.accentPrimary;
            const rippleStyle = {
                height: DOT_SIZE,
                width: DOT_SIZE,
                borderRadius: DOT_SIZE / 2,
                borderWidth: 0,
                backgroundColor: dotColor,
                transform: [
                    {
                        scale: this.progress.interpolate({
                            inputRange: [0, 1 - Math.pow(RIPPLE_FACTOR, index), 1],
                            outputRange: index ? [0.0, 0.0, 1.0] : [0.33, 0.33, 0.33],
                        }),
                    },
                ],
                opacity: this.progress.interpolate({
                    inputRange: [0, 1 - Math.pow(RIPPLE_FACTOR, index), 1],
                    outputRange: index ? [1.0, 1.0, 0.0] : [1.0, 1.0, 1.0],
                }),
            };
            return (<Animated.View style={styles.dot} {...{ key: index }}>
        <Animated.View style={rippleStyle}/>
      </Animated.View>);
        };
        this.progress = new Animated.Value(0);
        this.dots = new Array(DOT_COUNT);
    }
    createAnimationLoop() {
        this.animation = Animated.loop(Animated.timing(this.progress, Object.assign({}, animationConfig, { toValue: 1 })));
    }
    // Provide imperative access via ref to start and stop animation loop manually
    start() {
        this.createAnimationLoop();
        this.animation.start();
    }
    stop() {
        this.animation.stop();
        this.progress.setValue(0);
    }
    componentDidMount() {
        this.createAnimationLoop();
        if (this.props.autoplay) {
            this.animation.start();
        }
    }
    render() {
        const _a = this.props, { style } = _a, props = __rest(_a, ["style"]);
        return (<View style={[styles.container, style]} {...props}>
        {Array.from(this.dots, this.renderDots)}
      </View>);
    }
}
NewIndicator.defaultProps = {
    autoplay: true,
};
const styles = StyleSheet.create({
    container: {
        width: DOT_SIZE,
        height: DOT_SIZE,
    },
    dot: Object.assign({}, StyleSheet.absoluteFillObject),
});
export default withTheme(NewIndicator);
